// @flow
import React from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withTranslation } from 'react-i18next';
import VolumeUp from '@material-ui/icons/VolumeUp';
import styled from 'styled-components';

import { Menu, MenuItem, withTheme } from '@material-ui/core';
import { isDefaultRoomId } from '../../utils/ws-v1';

type Props = {
  status: Object,
  updateSpeakerListened: Function,
  scribe: boolean,
  speakerListened: string,
  theme: Object,
};

type State = {
  anchorEl: Object,
  forceSR: boolean,
};

const audioLinkData = {
  id: 'audioLink',
  avaId: 'audioLink',
  device: 'audioLink',
  forceSR: false,
  audioLink: true,
  muted: false,
  sampleRateHertz: 16000,
};

const BackendBadge = styled.div`
  margin-left: 30px;
  margin-right: 30px;
  padding-left: 6px;
  border-radius: 7px;
  padding-right: 6px;
  padding-top: 1px;
  padding-bottom: 2px;
  border-color: coral;
  border-style: solid;
  border-width: 1px;
  color: coral;
`;

const getShortDisplay = (participants, audioStream, speakers) => {
  const participant = participants[audioStream.avaId] || {};
  let an;
  if (audioStream.id === 'audioLink') {
    return 'smartAudio';
  }
  if (participant.avaName) {
    an = `&${participant.avaName}`;
  } else {
    an = 'guest';
  }
  if (speakers.filter(x => x.avaId === audioStream.avaId).length === 1) {
    an += ` ${speakers.filter(x => x.avaId === audioStream.avaId)[0].userName}`;
  }

  let device;
  if (audioStream.channel === 'web') {
    device = 'web';
  } else {
    ({ device } = audioStream);
  }

  return `${device} - (${an})`;
};

class SpeakerAudioSwitch extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      forceSR: false,
    };
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  updateSpeaker = speaker => {
    const { updateSpeakerListened } = this.props;
    const { forceSR } = this.state;
    this.setState({ anchorEl: null });
    updateSpeakerListened({ ...speaker, forceSR });
  };

  audioStreamListened = () => {
    const { status, speakerListened } = this.props;
    if (!status || !status.id || !status.audioStreams) {
      return {};
    }
    if (!speakerListened || speakerListened === 'host') {
      return (
        status.audioStreams.find(p => p.avaId === status.id.split('_')[0]) || {}
      );
    }
    if (speakerListened === 'audioLink') {
      return audioLinkData;
    }
    return status.audioStreams.find(p => p.avaId === speakerListened) || {};
  };

  handleForceSRChange() {
    const { forceSR } = this.state;
    this.setState({ forceSR: !forceSR }, () =>
      this.updateSpeaker(this.audioStreamListened())
    );
  }

  render() {
    const { status, scribe, theme } = this.props;
    const { anchorEl, forceSR } = this.state;
    if (!status.participants) {
      return null;
    }
    if (!status.scribe) {
      return null;
    }
    if (isDefaultRoomId(status.id)) {
      return null;
    }
    if (!scribe) {
      return null;
    }
    const speakers = {};
    status.participants.forEach(p => {
      speakers[p.avaId] = p;
    });
    const audioStreamsListened = this.audioStreamListened();
    if (status.audioStreams.length <= 1) {
      if (!audioStreamsListened) {
        return null;
      }
      return (
        <div style={{ color: theme.palette.contrast, marginLeft: 20 }}>
          {(audioStreamsListened || {}).device} &
          {(speakers[audioStreamsListened.id] || {}).avaName}
        </div>
      );
    }
    const streamsAndAudioLink = status.audioStreams.concat([audioLinkData]);
    return (
      <>
        <Button
          onClick={this.handleClick}
          className="a-button"
          type="submit"
          variant="outlined"
          style={{ width: 200, maxWidth: 200, marginLeft: 20 }}
        >
          <VolumeUp
            style={{
              width: 20,
              marginRight: 10,
            }}
          />
          <span
            style={{
              textTransform: 'none',
              color: theme.palette.contrast,
            }}
          >
            {getShortDisplay(speakers, audioStreamsListened, status.speakers)}
          </span>
        </Button>
        <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)}>
          {streamsAndAudioLink.map(p => (
            <MenuItem
              key={p.id}
              onClick={() => this.updateSpeaker(p)}
              selected={p.avaId === audioStreamsListened.avaId}
              disabled={p.muted}
            >
              {getShortDisplay(speakers, p, status.speakers)}
            </MenuItem>
          ))}
        </Menu>
        <FormControlLabel
          control={(
            <Switch
              size="small"
              checked={forceSR}
              color="default"
              onChange={() => this.handleForceSRChange()}
            />
)}
          label="Force captions"
        />
        {status.scribe && status.scribe.status === 'leaving' && (
          <div style={{}}>
            <BackendBadge>Scribe end requested</BackendBadge>
          </div>
        )}
      </>
    );
  }
}

export default withTranslation()(withTheme(SpeakerAudioSwitch));
